const getRedirectUrl = (intent: string) => {
  switch (intent) {
    case 'advice':
      return '/talent/advice';
    case 'education':
      return '/talent/resources';
    case 'mental_health':
      return '/talent/mental_health';
    case 'network':
      return '/talent/community';
    case 'resume':
      return '/nurse_profile/resume_generator/work-experience';
    case 'salary':
      return '/talent/salary_calculator';
    case 'interview_practice':
      return '/talent/resources#interview-practice';
    default:
      return '/talent/home';
  }
};

export default getRedirectUrl;
